import { Box, Flex, Tabs, Text } from 'ui'

import { format } from 'date-fns'
import { reverse } from 'ramda'
import { toTitleCase } from 'lib/string'
import { useWorkerProfileContext } from '../context/WorkerProfileProvider'

export function WorkHistory() {
  const { state: profile } = useWorkerProfileContext()
  const workExperience = profile.worker.workProfile?.workExperience || []

  const renderSkills = (skillsStr: string) => {
    if (!skillsStr) {
      return null
    }

    try {
      const skills = JSON.parse(skillsStr) as string[]
      if (skills.length === 0) {
        return null
      }
      return `Skills: ${skills.join(', ')}`
    } catch {
      return null
    }
  }

  return (
    <Box py={4}>
      <Tabs
        defaultValue={'experience'}
        tabs={[{ value: 'experience', label: 'Work Experience' }]}
      >
        <Tabs.Content value={'experience'}>
          <Box py={2}>
            {workExperience.length > 0 ? (
              reverse(workExperience).map((exp, expIdx) => (
                <Box
                  key={exp.id}
                  py={3}
                  mb={3}
                  borderStyle={'solid'}
                  borderColor={'neutrals.200'}
                  borderTopWidth={expIdx > 0 ? 1 : 0}
                >
                  <Flex mb={3}>
                    <Box flex={1} fontWeight={2} mr={2}>
                      {exp.companyName},{' '}
                      {toTitleCase((exp.experience || '').replace(/_/g, ' '))}
                    </Box>
                    {exp.startedAt || exp.endedAt ? (
                      <Text fontSize={1} ml={2}>
                        {exp.startedAt
                          ? format(new Date(exp.startedAt), 'MMM yyyy')
                          : ''}
                        {exp.startedAt && exp.endedAt ? ' - ' : ''}
                        {exp.endedAt
                          ? format(new Date(exp.endedAt), 'MMM yyyy')
                          : ''}
                      </Text>
                    ) : null}
                  </Flex>
                  {exp.skills ? (
                    <Box color={'lightText'}>{renderSkills(exp.skills)}</Box>
                  ) : null}
                </Box>
              ))
            ) : (
              <Text>Worker has not entered their work experience.</Text>
            )}
          </Box>
        </Tabs.Content>
      </Tabs>
    </Box>
  )
}
